import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  props: {
    circleRadius: {
      type: Object,
      required: true,
    },
    map: {
      type: Object,
      required: true,
    },
  },
})
export default class BbGoogleMapCircleRadiusComponent extends Vue {
  gmapsCircleRadius = null;

  /**
   * Create a radius over the marker in case the activity is a delivery type.
   */
  created() {
    this.gmapsCircleRadius = new window.google.maps.Circle({
      radius: this.circleRadius.radius,
      center: this.circleRadius.center,
      map: this.map,
      ...this.circleRadius.settings,
    });
  }
}
